import React from "react";
import PropTypes from "prop-types";
import IconCard from "components/Cards/IconCard.jsx";
import { BarStacked } from "components/Charts";
import Reports from "models/Reports";

// Styles
import ThumbsUpDown from "material-ui-icons/ThumbsUpDown";
import withStyles from "material-ui/styles/withStyles";
import chartsStyle from "assets/jss/material-dashboard-pro-react/views/chartsStyle";

export const ModalitySuccessFailure = ({ report }) => {
  let labels = [];
  let xSeries = null;
  if (report) {
    let failures = [];
    let successes = [];
    const modalities = report.modalityStatsBy("modality");
    const modalityKeys = Object.keys(modalities);
    if (modalityKeys.length) {
      modalityKeys.forEach(mod => {
        labels.push(mod);
        successes.push(modalities[mod].successful);
        failures.push(modalities[mod].failures);
      });
      xSeries = [
        failures.map(n => ({ value: n, meta: { style: "stroke: #ef5350; stroke-width: 30px;" } })),
        successes.map(n => ({ value: n, meta: { style: "stroke: #0fb8ad; stroke-width: 30px;" } })),
      ];
    }
  }


  return (
    <IconCard
      iconColor="orange"
      icon={ThumbsUpDown}
      title="Modality Success & Failures"
      content={<BarStacked
        noXSeriesRender={() => <h3><small>No report</small></h3>}
        emptyXSeriesRender={() => <h3><small>No modalities reported for this date range</small></h3>}
        legendTitle="Legend"
        legend={["Failure", "Success"]}
        xLabels={labels}
        xSeries={xSeries}
      />}
    />
  );
};

ModalitySuccessFailure.propTypes = {
  report: PropTypes.instanceOf(Reports)
};

export default withStyles(chartsStyle)(ModalitySuccessFailure);